const ColorThemeTypeList = ['gray', 'purple', 'green', 'red', 'blue'] as const
type ColorThemeTypeTuple = typeof ColorThemeTypeList
type ColorThemeListingType = ColorThemeTypeTuple[number]

export const isValidColorTheme = (theme: string | undefined): theme is ColorThemeListingType => {
  return ColorThemeTypeList.includes(theme as ColorThemeListingType)
}

export const getBgColorThemeClass = (colorTheme: string, type: 'light' | 'dark') => {
  if (!isValidColorTheme(colorTheme)) {
    return ''
  }

  const darkThemeClasses = {
    gray: 'u-bg-black',
    purple: 'u-bg-dark-purple',
    green: 'u-bg-dark-green',
    blue: 'u-bg-dark-blue',
    red: 'u-bg-dark-red',
  } as const

  const lightThemeClasses = {
    gray: 'u-bg-light-gray',
    purple: 'u-bg-light-purple',
    green: 'u-bg-light-green',
    blue: 'u-bg-light-blue',
    red: 'u-bg-light-red',
  } as const

  return type === 'dark' ? darkThemeClasses[colorTheme] : lightThemeClasses[colorTheme]
}

export const getColorThemeClass = (colorTheme: string) => {
  if (!isValidColorTheme(colorTheme)) {
    return ''
  }

  const themeClasses = {
    gray: 'u-color-black',
    purple: 'u-color-dark-purple',
    green: 'u-color-dark-green',
    blue: 'u-color-dark-blue',
    red: 'u-color-dark-red',
  } as const

  return themeClasses[colorTheme]
}
